import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';
import { toast } from '../utils/toast';
import './Auth.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      toast.error('Токен не предоставлен');
      navigate('/forgot-password');
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Пароли не совпадают');
      return;
    }

    if (password.length < 8) {
      toast.error('Пароль должен содержать минимум 8 символов');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/auth/reset-password', { token, password });
      if (response.data && response.data.success) {
        setSuccess(true);
        toast.success(response.data.message || 'Пароль успешно изменен!');
        // Перенаправляем на страницу входа через 3 секунды
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        toast.error(response.data.error || 'Ошибка при изменении пароля');
      }
    } catch (error) {
      console.error('Reset password error:', error);
      toast.error(error.response?.data?.error || 'Ошибка при изменении пароля');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>SAVEL'EV CRM</h1>
            <h2>Восстановление пароля</h2>
          </div>
          <div className="verification-status error">
            <div className="error-icon">❌</div>
            <p>Токен не предоставлен</p>
            <Link to="/forgot-password" className="btn btn-primary">Запросить новую ссылку</Link>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>SAVEL'EV CRM</h1>
            <h2>Пароль изменен</h2>
          </div>
          <div className="verification-status success">
            <div className="success-icon">✅</div>
            <p>Пароль успешно изменен!</p>
            <p className="redirect-message">Перенаправление на страницу входа...</p>
            <Link to="/login" className="btn btn-primary">Перейти к входу</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>SAVEL'EV CRM</h1>
          <h2>Восстановление пароля</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Новый пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input"
              placeholder="Введите новый пароль (минимум 8 символов)"
              minLength="8"
            />
          </div>
          <div className="form-group">
            <label>Подтвердите пароль</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="input"
              placeholder="Повторите новый пароль"
              minLength="8"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Изменение...' : 'Изменить пароль'}
          </button>
          <div className="auth-links">
            <Link to="/login">Вспомнили пароль? Войти</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
